export const getProjects = () => [
	{
		name: "Scheduulr",
		description:
			"Schedule appointments with ease within your organisation while keeping track of attendeesʼ schedules. A ‘calendly like’ appointment scheduling application using ReactJS, Node and Google Calendar APIs",
		platform: "web",
		stack:
			"React, Ant Design, Express, Google Calendar API, Express, MongoDB, NGINX, AWS",
		demo: "https://scheduulr.srmist.edu.in/",
	},
	{
		name: "Splash",
		description:
			"An unsplash-clone, i.e. interactive image gallery with infinite scroll and dynamic arrangement",
		platform: "web",
		stack: "React, Tailwind, Sass, Unsplash APIs",
		demo: "https://splash-clone.vercel.app/",
	},
	{
		name: "HooBank",
		description: "A banking Landing web page",
		platform: "web",
		stack: "React, Tailwind,",
		demo: "https://landing-bank.vercel.app/",
	},
	{
		name: "Event/Phone Scheduler",
		description:
			"A ‘google calendar like’ event/phone call scheduler built using React and Redux",
		platform: "web",
		stack: "React, Redux, Tailwind, Sass, Unsplash APIs",
		demo: "https://scheduler-harshgour.vercel.app/",
	},
	{
		name: "Host Engine",
		description:
			"A decentralized web hosting platform using IPFS and Ethereum Blockchain.",
		platform: "web",
		stack: "HTML, CSS, JS, Solidity, IPFS",
	},
	{
		name: "FB Helpdesk",
		description:
			"A fullstack Facebook agent helpdesk with live chatting and comments options.",
		platform: "web",
		stack: "React, NodeJS, Facebook Dev APIs, Socket",
	},
	{
		name: "Hacktrix",
		description:
			"Landing website for a Hackathon named ‘Hacktrix’, which was an entry point for several hackers.",
		platform: "web",
		stack: "React, styled-components, Devfolio APIs, NodeJS, Vercel",
		demo: "https://hacktrix.ieeesrmist.in/",
	},
	{
		name: "Concepto",
		description:
			"Developed website for college event ‘Concepto’, which served as a landing page and registration portal for participants.",
		platform: "web",
		stack: "React, Vercel",
		demo: "https://concepto.ieeesrmist.in/",
	},
	{
		name: "IEEE Events",
		description:
			"The registration portal for IEEESRM events with live event status. Data gets saved to google sheets upon form registration.",
		platform: "web",
		stack: "React, Styled Components, Express, MongoDB, Google Sheets",
		demo: "https://register.ieeesrmist.in/",
	},
	{
		name: "Todo",
		description:
			"Developed a Fullstack todo application using React Native(frontend) and Node(backend).",
		platform: "android",
		stack: "React Native, Node",
	},
	{
		name: "Onboarding Mockup UI",
		description: "Just an onboarding mockup design UI.",
		platform: "web",
		stack: "React, Tailwind",
		demo: "https://onboarding-mockup.vercel.app/",
	},
];
